import {
  httpGet
} from '@/api'
let prefix = '/org/resourceApi/'

export const apidocList = (params) => httpGet(prefix + 'tree', params) // API文档列表
